import React from 'react';
import PropTypes from 'prop-types';

import useAppContext from '../../context/useAppContext';
import { ToastContext } from '@weezevent/nacre';
import Subscription from '../../models/subscription';
import { Route, Switch, useHistory } from 'react-router-dom';
import Template from '../../components/template/template';
import Loading from '../../components/loading';
import WebserviceHome from '../../pages/webservicesV2/home/home';
import PageError from '../../pages/error/pageError';
import { useTranslation } from 'react-i18next';
import SubscriptionDistributor from '../../pages/webservicesV2/subscription';
import TicketList from '../../pages/webservicesV2/ticketList/ticketList';
import Mapping from '../../pages/webservicesV2/mapping/mapping';
import ManagementRules from '../../pages/webservicesV2/managementRulesList/managementRulesList';
import SubscriptionLinks from '../../pages/webservicesV2/subscriptionLinks/subscriptionLinks';
export default function WebserviceRouter({ match: { path }, organization, subscriptionId }) {
    const [context, setContext] = useAppContext();
    const toast = React.useContext(ToastContext);
    const { t } = useTranslation();
    const history = useHistory();

    const [, loading] = Subscription.useApiModel(
        {
            id: subscriptionId,
            organizationId: organization.id,
            onSuccess: webservice => {
                setContext({ webservice });
            },
            onError: e => {
                if (e.code === 404) {
                    toast.error(t('pageNotFound'));
                } else {
                    toast.error(t('ticket.common.toast_error'));
                }
                history.push(`/ticket/O${organization.id}/webservices`);
            }
        },
        [subscriptionId, organization]
    );

    if (loading || !context.webservice) {
        return <Loading />;
    }

    return (
        <Template organization={organization} webservice={context.webservice?.type === 'hook' ? context.webservice : null}>
            <Switch>
                <Route
                    exact
                    path={`${path}/`}
                    render={({
                        match: {
                            params: { subscriptionId }
                        }
                    }) => <SubscriptionDistributor organizationId={organization.id} subscriptionId={subscriptionId} />}
                />
                <Route
                    exact
                    path={`${path}/dashboard`}
                    render={({
                        match: {
                            params: { subscriptionId }
                        }
                    }) => <WebserviceHome organization={organization} subscriptionId={subscriptionId} />}
                />
                <Route
                    exact
                    path={`${path}/mapping`}
                    render={({
                        match: {
                            params: { subscriptionId }
                        }
                    }) => <Mapping subscriptionId={subscriptionId} organizationId={organization.id} />}
                />
                <Route
                    exact
                    path={`${path}/attendees`}
                    render={({
                        match: {
                            params: { subscriptionId }
                        }
                    }) => <TicketList organizationId={organization.id} subscriptionId={subscriptionId} />}
                />
                <Route
                    exact
                    path={`${path}/subscription_links`}
                    render={({
                        match: {
                            params: { subscriptionId }
                        }
                    }) => <ManagementRules subscriptionId={subscriptionId} organizationId={organization.id} />}
                />
                <Route
                    exact
                    path={`${path}/subscription_links/new`}
                    render={({
                        match: {
                            params: { subscriptionId }
                        }
                    }) => <SubscriptionLinks subscriptionId={subscriptionId} organizationId={organization.id} />}
                />

                <Route
                    exact
                    path={`${path}/subscription_links/:linkId([0-9]+)`}
                    render={({
                        match: {
                            params: { subscriptionId, linkId }
                        }
                    }) => <SubscriptionLinks subscriptionId={subscriptionId} linkId={linkId} organizationId={organization.id} />}
                />
                {/* Error */}
                <Route render={() => <PageError errorCode={404} backHomeUrl={`/ticket/O${organization.id}/webservices/${subscriptionId}/dashboard`} />} />
            </Switch>
        </Template>
    );
}

WebserviceRouter.propTypes = {
    match: PropTypes.object,
    organization: PropTypes.object,
    subscriptionId: PropTypes.string
};
